import type { Modal } from '@ps/web-core-store';
import type React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

const objHasRemainingSeconds = (
  obj: object | { remainingSeconds: number }
): obj is { remainingSeconds: number } =>
  'remainingSeconds' in obj && typeof obj.remainingSeconds === 'number';

const useInactivityTimeout = (): {
  showInactivityPrompt: boolean;
  remainingSeconds: number;
  setShowInactivityPrompt: React.Dispatch<React.SetStateAction<boolean>>;
} => {
  const { path, locationState } = (useSelector(select.modal.getCurrent) || {}) as Partial<Modal>;
  const { modal } = useDispatch<Dispatch>();
  const [showInactivityPrompt, setShowInactivityPrompt] = useState(false);
  const [remainingSeconds, setRemainingSeconds] = useState<number>(0);

  useEffect(() => {
    if (
      path === '/notifications/inactivity-timeout-warning' &&
      locationState &&
      objHasRemainingSeconds(locationState)
    ) {
      setShowInactivityPrompt(true);
      setRemainingSeconds(locationState.remainingSeconds);
      modal.close('/notifications/inactivity-timeout-warning');
    }
  }, [locationState, path, modal]);

  return { showInactivityPrompt, remainingSeconds, setShowInactivityPrompt };
};

export default useInactivityTimeout;
